import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import { toast } from "react-toastify";
import { resetStatusFilters, setOpenFilter, setStatusFilters } from "../bloc/beneficiariesSlice";

const statusOptions = [
    {
        label: "All",
        value: "ALL",
    },
    {
        label: "Active",
        value: "ACTIVE",
    },
    {
        label: "Inactive",
        value: "INACTIVE",
    }
];

const useFilters = () => {

    const dispatch = useDispatch();

    const { statusFilters } = useSelector((state: TRootState) => ({
        statusFilters: state.beneficiary.statusFilters
    }))

    const [status, setStatus] = useState<string[]>([]);

    const handleStatusClick = (value: string) => {
        if (value === "ALL") {
            if (status.length === statusOptions.length - 1) {
                setStatus([]);
            } else {
                setStatus(statusOptions
                    .filter((t) => t.value !== "ALL")
                    .map((t) => t.value)
                );
            }
            return;
        }

        let updated = [...status];

        if (updated.includes(value)) {
            updated = updated.filter((v) => v !== value);
        } else {
            updated.push(value);
        }

        setStatus(updated);
    };

    useEffect(() => {
        if (statusFilters?.status.length > 0) {
            setStatus(statusFilters?.status);
        }
    }, [statusFilters]);

    const handleApplyFilters = () => {
        dispatch(
            setStatusFilters({
                status: status,
            })
        );
        dispatch(setOpenFilter(false));
    };

    const handleResetFilters = () => {
        dispatch(resetStatusFilters());
        setStatus([]);
        toast.success("Filters reset successfully");
    };

    return {
        handleStatusClick,
        handleApplyFilters,
        handleResetFilters,
        status,
        setStatus,
        statusOptions,
        statusFilters
    }
}
export default useFilters;